import React from 'react'
import { CardList } from './styles'
import { Link } from 'react-router-dom'

interface CardProps {
  list: any[]
}

const Card = ({list}: CardProps) => {
  return (
    <CardList>
      <ul>
        {
          list.map((item, index) => {
            const productId = item.product_id || item.id
            const thumbnailList = item.thumbnail ? JSON.parse(item.thumbnail) : []
            const imageList = item.images ? JSON.parse(item.images) : []
            const imagePath = item.img || thumbnailList?.[0]?.path || imageList?.[0]?.path || ''

            return (
              <li key={index}>
                <Link to={`/shop/detail/${productId}`}>
                  <div
                    className='figure'
                    style={{background: imagePath ? `url('${process.env.REACT_APP_BASE_URL}${imagePath}') no-repeat center / contain` : 'none'}}
                  ></div>
                </Link>
                <div className="info">
                  <span className="title">{item.name}</span>
                  <span className="price">{item.price?.toLocaleString()}원</span>
                </div>
              </li>
            )
          })
        }
      </ul>
    </CardList>
  )
}

export default Card
